import { Box, Button, Dialog, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HistoryIcon from '@material-ui/icons/History';
import React, { useState } from 'react';

import { FontSizes } from '../../core/config/mainTheme';
import { toCssValue } from '../../core/utils/theme.utils';
import { MainColumns } from '../TableGrid';
import HistoricalTable from '../Tables/historicalTable';
import DialogTitleBlock from './Dialog/DialogTitleBlock';

interface OwnProps {
  columns: MainColumns[];
  data?: any[];
  label: string;
  title: string;
  translationsScope: string;
}

const HistoricalModal: React.FC<OwnProps> = ({
  columns,
  data,
  label,
  title,
  translationsScope,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <Box>
      <Button
        onClick={() => {
          setOpen(!open);
        }}
        className={classes.btn}
        startIcon={<HistoryIcon />}
        size="small"
        color="primary"
        disableFocusRipple
      >
        {label}
      </Button>

      <Dialog
        onClose={() => {
          setOpen(!open);
        }}
        open={open}
        className={classes.dialogBox}
      >
        <DialogTitleBlock icon={<HistoryIcon />} title={title} handleClose={() => setOpen(false)} />
        <DialogContent>
          <HistoricalTable columns={columns} rows={data} translationsScope={translationsScope} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  input: {
    padding: theme.spacing(0),
  },
  dialogBox: {
    '& .MuiDialogContent-root .MuiPaper-root': {
      borderRadius: 0,
    },
    '& .MuiDialogContent-root': {
      padding: 0,
    },
    '& .MuiPaper-root': {
      minWidth: '500px',
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(2),
    color: theme.palette.grey[500],
  },
  btn: {
    textTransform: 'none',
    fontWeight: FontSizes.fontWeight.bold,
    padding: toCssValue([theme.spacing(2), theme.spacing(2), theme.spacing(2), 0]),
    lineHeight: 1,
  },
}));

export default HistoricalModal;
